module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAANCAMAAABrcDXcAAAAV1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////+ORg7oAAAAHHRSTlMA+w3b9+Q2KhbLxfHu69KxlYJ7cmZgVk9GQSIcep2C4QAAAINJREFUGNNlj9kOgzAMwNIySrnv2///nWs0hFjxkyUrSiKdaa3E2NZ0YiD3UfA5GOmB5PwLZwL0IgOQZo+QpcCgNhmo3R1cDWb6+RJSuV9hL0NY5GL7wGcVZVXd5MZVYOYgs4HKSbx1lDG6Rjn00kI/OCTCNyiNlxe20Ckb7J1ykkf4AkluCSlZuR3HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-arrow-down.png
// module id = 286
// module chunks = 114276838955818 159515537771391